import { isArray, isFunction, isPlainObject, isString } from 'lodash-es';

import { CANCEL, SELF_CANCELLATION, SIGNAL } from './innerActionSymbol';

export const EFFECT = {
	PUT: 'PUT', // dispatch to store
	TAKE: 'TAKE', // catch action
	ALL: 'ALL', // modify all saga
	RACE: 'RACE', // race run multiple saga
	CALL: 'CALL', // call function.(support promise)
	FORK: 'FORK', // run saga in subTask
	CANCEL: 'CANCEL', // cancel task
	CANCELLED: 'CANCELLED',
	SELECT: 'GET', // get state data
};

const isEffect = (eff) => eff && eff[SIGNAL];
const isForkEffect = (eff) => isEffect(eff) && eff.type === EFFECT.FORK;

const createEffectSignal = (type, payload) => {
	return {
		[SIGNAL]: true,
		combinator: false,
		type,
		payload,
	};
};

/**
 * @param {string|string[]|function} pattern - action type or type list or function
 */
export const take = (pattern = '*') => {
	return createEffectSignal(EFFECT.TAKE, { pattern });
};
export const put = (action) => {
	return createEffectSignal(EFFECT.PUT, { action });
};
export const putResolve = (...args) => {
	const eff = put(...args);
	eff.payload.resolve = true;
	return eff;
};
export const all = (effects) => {
	const eff = createEffectSignal(EFFECT.ALL, effects);
	eff.combinator = true;
	return eff;
};

// export const race = (effects)=>{
//     const eff = createEffectSignal(EFFECT.RACE, effects);
//     eff.combinator = true;
//     return eff;
// };

const getFnDescriptor = (fnDescriptor, args) => {
	let context = null,
		fn;
	if (isFunction(fnDescriptor)) {
		fn = fnDescriptor;
	} else {
		if (isArray(fnDescriptor)) {
			[context, fn] = fnDescriptor;
		} else if (isPlainObject(fnDescriptor)) {
			({ context, fn } = fnDescriptor);
		}
		if (context && isString(fn) && isFunction(context[fn])) {
			fn = context[fn];
		}
	}
	return { context, fn, args };
};
export const call = (fnDescriptor, ...args) => {
	return createEffectSignal(EFFECT.CALL, getFnDescriptor(fnDescriptor, args));
};
export const fork = (fnDescriptor, ...args) => {
	return createEffectSignal(EFFECT.FORK, getFnDescriptor(fnDescriptor, args));
};
export const cancel = (task = SELF_CANCELLATION) => {
	return createEffectSignal(EFFECT.CANCEL, task);
};
export const cancelled = () => {
	return createEffectSignal(EFFECT.CANCELLED, {});
};
const identity = (v) => v;
export const get = (selector = identity, ...args) => {
	return createEffectSignal(EFFECT.SELECT, { selector, args });
};

const delayP = (ms, val = true) => {
	let timeoutId;
	const promise = new Promise((resolve) => {
		timeoutId = setTimeout(resolve, ms, val);
	});
	promise[CANCEL] = () => {
		clearTimeout(timeoutId);
	};
	return promise;
};
export const delay = call.bind(null, delayP);

export const takeLastestEvery = (pattern, saga, ...args) =>
	fork(function* () {
		let lastTask;
		while (true) {
			const action = yield take(pattern);
			if (lastTask) {
				yield cancel(lastTask);
			}
			lastTask = yield fork(saga, ...args.concat(action));
		}
	});
